module.exports = __webpack_public_path__ + "img/2025-logo.0a7332f2.png";